import type { ReactNode } from 'react';

/**
 * Kennzahl-Kachel. Die Zahl ist hier das Diagramm — ein Balken für einen Wert
 * wäre Dekoration.
 *
 * Bewusst proportionale Ziffern (kein `tabular-nums`): bei Displaygrößen lässt
 * gleiche Zifferbreite Zahlen wie „121" auseinandergezogen wirken. Tabellarische
 * Ziffern gehören in die Tabellenansicht, wo Spalten fluchten müssen.
 */
export default function StatTile({
  label,
  value,
  sub,
  accent,
}: {
  label: string;
  value: string;
  sub?: ReactNode;
  accent?: string;
}) {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="text-xs font-medium text-gray-500">{label}</div>
      <div className="text-2xl font-bold mt-1" style={{ color: accent ?? '#0b0b0b' }}>
        {value}
      </div>
      {sub && <div className="text-xs text-gray-400 mt-0.5">{sub}</div>}
    </div>
  );
}
